import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';

export const LanguageToggle = ({ variant = 'default' }) => {
  const { language, setLanguage, t } = useLanguage();

  const buttonClass = variant === 'light' 
    ? 'text-white hover:bg-white/10 border-white/30' 
    : 'text-[#467322] hover:bg-[#F2F7F0] border-[#467322]/30';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="outline" 
          size="sm" 
          className={`gap-2 ${buttonClass}`}
          data-testid="language-toggle"
        >
          <Globe size={16} />
          <span className="uppercase font-semibold">{language}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white border border-[#467322]/20">
        <DropdownMenuItem 
          onClick={() => setLanguage('es')}
          className={`cursor-pointer ${language === 'es' ? 'bg-[#F2F7F0] text-[#467322] font-semibold' : ''}`}
          data-testid="language-es"
        >
          <span className="mr-2">🇪🇸</span> {t('spanish')}
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => setLanguage('en')}
          className={`cursor-pointer ${language === 'en' ? 'bg-[#F2F7F0] text-[#467322] font-semibold' : ''}`}
          data-testid="language-en"
        >
          <span className="mr-2">🇺🇸</span> {t('english')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageToggle;
